export interface DisposableMpegtsPlayer {
  pause: () => void,
  unload: () => void,
  detachMediaElement: () => void,
  destroy: () => void
}

export function destroyMpegtsPlayer (player: DisposableMpegtsPlayer | null) {
  if (!player) {
    return
  }
  player.pause()
  player.unload()
  player.detachMediaElement()
  player.destroy()
}
